export default __webpack_public_path__ + "static/media/Wink.8e3d41fc.svg";